import type {
  GetSearchAutocompletePayload,
  GetSearchResultsPayload,
  GetSearchResultsResponse,
  PublishSearchTrackPayload,
} from "~/repository/search.types";

export async function getSearchAutocomplete(
  payload: GetSearchAutocompletePayload,
): Promise<string[]> {
  const { query } = payload;
  const { $api } = useNuxtApp();
  return await $api("v4")(`search/autocomplete?query=${query}&maxResults=10`);
}

export async function getSearchResults(
  payload: GetSearchResultsPayload,
): Promise<GetSearchResultsResponse> {
  const { query, sortField, sortDirection } = payload;
  const { $api } = useNuxtApp();
  return await $api("v4")(
    `search?query=${query || ""}&sortField=${sortField || ""}&sortDirection=${sortDirection || ""}`,
  );
}

export async function publishSearchTrack(payload: PublishSearchTrackPayload) {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/search/track`, {
    method: "POST",
    body: payload,
  });
}
